import { render, staticRenderFns } from "./BMenuContainer.vue?vue&type=template&id=6dfeda06&scoped=true&"
import script from "./BMenuContainer.vue?vue&type=script&lang=js&"
export * from "./BMenuContainer.vue?vue&type=script&lang=js&"
import style0 from "./BMenuContainer.vue?vue&type=style&index=0&id=6dfeda06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfeda06",
  null
  
)

export default component.exports